import { create } from "zustand";
import { AccountCode } from "types";

type AccountCodeState = {
  rows: AccountCode[];
  editingId: number | null;
  isLoading: boolean;
  setRows: (rows: AccountCode[]) => void;
  upsertRow: (row: AccountCode) => void;
  removeRow: (id: number | string) => void;
  setEditingId: (id: number | null) => void;
  setLoading: (loading: boolean) => void;
  reset: () => void;
};

export const useAccountCodeStore = create<AccountCodeState>()((set) => ({
  rows: [],
  editingId: null,
  isLoading: false,
  setRows: (rows) => set({ rows: rows || [] }),
  upsertRow: (row) =>
    set((state) => {
      const exists = state.rows.find((item) => item.id === row.id);
      const rows = exists
        ? state.rows.map((item) =>
            item.id === row.id ? { ...item, ...row } : item,
          )
        : [row, ...state.rows];
      return { rows };
    }),
  removeRow: (id) =>
    set((state) => ({
      rows: state.rows.filter((item) => String(item.id) !== String(id)),
    })),
  setEditingId: (id) => set({ editingId: id }),
  setLoading: (loading) => set({ isLoading: loading }),
  reset: () => set({ rows: [], editingId: null, isLoading: false }),
}));
